import { createUseStyles } from 'react-jss'
import { trafficRedDark } from '../../../styles/const/colors'

const useStyles = createUseStyles({
  error: {
    color: trafficRedDark,
    fontSize: ({ fontSize }) => fontSize || 11,
    paddingTop: 5,
    paddingLeft: 5,
    lineHeight: '14px',
    textAlign: 'left'
  }
})

export default useStyles
